/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { getSafely } from 'core/utils/legacyUtils';
import { WistiaPlayer } from 'edrolo/domains/video';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import ExamQuestionMultipleChoiceList from 'edrolo/components/exams/solutions/ExamQuestionMultipleChoiceList';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

class SolutionModal extends Component {
  state = {
    showModal: false,
  };

  close = () => {
    this.setState({
      showModal: false,
    });
  };

  open = () => {
    this.setState(
      {
        showModal: true,
      },
      function () {
        analytics.track('viewed solution modal', {
          origin: this.props.origin,
          question_id: this.props.question.id,
          ...this.props.analyticsPayload,
        });
      }
    );
  };

  render() {
    const question = this.props.question;
    const solutionData = this.props.solutionData;
    const answerSolutions = getSafely(solutionData, ['answers']);
    const explanation = getSafely(solutionData, ['solution', 'explanation']);
    const isMultipleChoice =
      question.question_type === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE;
    const video = getSafely(solutionData, ['solution', 'video']);

    const instructions = question.instructions;
    return (
      <div className="solution-modal">
        <span onClick={this.open}>{this.props.children}</span>
        <Modal show={this.state.showModal} onHide={this.close}>
          <div className="modal-body" id="teacher-solution">
            <h5>
              <span dangerouslySetInnerHTML={{ __html: instructions }} />
              {isMultipleChoice ? null : (
                <span className="marks">
                  {`(${Math.round10(question.marks, 0)} marks)`}
                </span>
              )}
            </h5>
            {isMultipleChoice ? (
              <ExamQuestionMultipleChoiceList
                answers={question.answers}
                answerSolutions={answerSolutions}
              />
            ) : null}
            {video && video.wistia_hashed_id && (
              <WistiaPlayer
                videoHash={video.wistia_hashed_id}
                thumbnailUrl={WistiaUtils.getThumbnail(video)}
                origin="exam_grid"
                appLabel="exam"
                model="question"
                objectId={question.id}
                speedControl
              />
            )}
            {explanation && (
              <div className="solution-text">
                <span dangerouslySetInnerHTML={{ __html: explanation }} />
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default SolutionModal;
